import instance from '@/api/instance'
import { iClient } from '@/types/responses'

export const getClientById = (id: number) =>
  instance.get<iClient>('clients/get-by-id', { params: { id } })
export const suggestClient = (term: string) =>
  instance.get<iClient[]>('clients/suggest', { params: { term } })
